export default __webpack_public_path__ + "static/media/logout.e5aa2dea.svg";